import React, {memo, useMemo} from "react"
import {ControlModel, CONTROL_TYPE_GENERAL_TEMPERATURE} from "../../../types/control"
import {DefaultTemperatureComponent} from "./component"
type Props = {
    control: ControlModel
}
export const DefaultTemperature = memo(function DefaultTemperature({control}: Props) {
    const defaultTemperature = useMemo(() => {
        if (control.type_id === CONTROL_TYPE_GENERAL_TEMPERATURE) {
            return [control.temperature_settings.room_whole, control.temperature_settings.room_fraction]
        }
        return [0, 0]
    }, [control])

    return <DefaultTemperatureComponent control={control} temp={defaultTemperature} />
})
